import { css } from '@emotion/core';

const styles = {
    container: css({
        maxWidth: '1400px',
        padding: '15px 0',
        margin: 'auto'
    }),
    filterSection: css({
        backgroundColor: '#f5f5f5',
        padding: '20px',
        // borderRadius: '8px',
        marginBottom: '30px'
    }),
    filterRow: css({
        display: 'flex',
        flexWrap: 'wrap',
        gap: '15px',
        marginBottom: '15px',
        alignItems: 'flex-end'
    }),
    filterGroup: css({
        flex: '1',
        minWidth: '200px',
        'label': {
            display: 'block',
            marginBottom: '5px',
            fontWeight: 'bold',
            color: '#333'
        },
        'select': {
            width: '100%',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '14px'
        }
    }),
    buttonGroup: css({
        display: 'flex',
        gap: '10px',
        marginTop: '15px'
    }),
    applyButton: css({
        backgroundColor: '#492865',
        color: 'white',
        border: 'none',
        padding: '10px 25px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#c41a1c'
        },
        '&:disabled': {
            backgroundColor: '#ccc',
            cursor: 'not-allowed'
        }
    }),
    exportButton: css({
        backgroundColor: '#333',
        color: 'white',
        border: 'none',
        padding: '10px 25px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#555'
        },
        '&:disabled': {
            backgroundColor: '#ccc',
            cursor: 'not-allowed'
        }
    }),
    resultsTable: css({
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '20px',
        'th, td': {
            border: '1px solid #ddd',
            padding: '12px 8px',
            textAlign: 'left',
            fontSize: '14px'
        },
        'th': {
            backgroundColor: '#492865',
            color: 'white',
            fontWeight: 'bold'
        },
        'tr:nth-of-type(even)': {
            backgroundColor: '#f9f9f9'
        },
        'tr:hover': {
            backgroundColor: '#f1f1f1'
        },
        // Hide table on mobile
        '@media (max-width: 768px)': {
            display: 'none'
        }
    }),
    // Mobile card view
    mobileResults: css({
        display: 'none',
        '@media (max-width: 768px)': {
            display: 'block'
        }
    }),
    mobileCard: css({
        backgroundColor: '#fff',
        border: '1px solid #ddd',
        // borderRadius: '8px',
        // marginBottom: '20px',
        overflow: 'hidden',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }),
    mobileCardHeader: css({
        backgroundColor: '#492865',
        color: 'white',
        padding: '12px 15px',
        fontWeight: 'bold',
        fontSize: '16px'
    }),
    mobileCardBody: css({
        padding: '0'
    }),
    mobileCardRow: css({
        display: 'flex',
        borderBottom: '1px solid #eee',
        '&:last-child': {
            borderBottom: 'none'
        }
    }),
    mobileCardLabel: css({
        flex: '0 0 140px',
        backgroundColor: '#f5f5f5',
        padding: '10px 12px',
        fontWeight: 'bold',
        fontSize: '13px',
        color: '#333',
        borderRight: '1px solid #eee'
    }),
    mobileCardValue: css({
        flex: '1',
        padding: '10px 12px',
        fontSize: '13px',
        color: '#555',
        wordBreak: 'break-word'
    }),
    noResults: css({
        textAlign: 'center',
        padding: '40px',
        color: '#666',
        fontSize: '16px'
    }),
    hint: css({
        color: '#666',
        fontStyle: 'italic',
        marginBottom: '15px'
    }),
    link: css({
        color: '#e21d20',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }),
    loading: css({
        textAlign: 'center',
        padding: '20px',
        color: '#666'
    })
};

export default styles;

